<template lang="pug">
  .column
    .column.m-bottom-2(v-if='showEvaluationMethods')
      .row.middle.m-bottom-05
        simple-svg.black-icon.m-right-1(:filepath='evaluationMethodIcon' width='20px' height='20px')
        label.text-small.dark-gray {{ $t("valuation.evaluationMethod") }}
      p.text-normal.m-left-3 {{ evaluationMethods }}
    .column.m-bottom-2(v-if='!emptyValuation')
      h2.title-medium.m-bottom-1 {{ $t("valuation.valuationTitle") }}
      .md-content.m-left-1(v-html='globalValuation')
    .column.m-bottom-2(v-if='globalValuationMaterials.length')
      .row.m4-bottom-5.middle.m-bottom-1
        img.material-icon.m-right-2(:src='downloadIcon' alt='downloadable material')
        h2.title-medium {{ $t("valuation.downloadableContent") }}
      .column.m-top-1
        .material(v-for='mat in globalValuationMaterials' :key='mat.id')
          .row.middle
            a.black.text-big(target='_blank' :href='mat.fileURI' rel='noreferrer noopener')
              | {{ mat.description }}
          button.secondary-button.with-icon.mobile-hide(type='button' @click='downloadFileWithNewFilename(mat.fileURI, mat.description)')
            simple-svg.blue-icon.m-right-1(:filepath='downloadIcon' width='20px' height='20px')
            | {{ innerI18n.t('teacher.download') }}
      .m-top-2.row.middle.end(v-if='globalValuationMaterials.length > 1')
        button.secondary-button.with-icon.mobile-hide(@click='downloadAllFiles')
          simple-svg.blue-icon.m-right-1(:filepath='downloadIcon' width='20px' height='20px')
          | {{ innerI18n.t('teacher.downloadAll') }}
</template>

<script>
import { mapState } from 'vuex'
import MarkdownIt from 'markdown-it'
import downloadIcon from '@/assets/ic_download.svg'
import { downloadFileWithNewFilename, zipFilesFromUrls } from '@/utils/download'
import { innerI18n } from '../../main'
import evaluationMethodIcon from '@/assets/ic_evaluation_method.svg'

export default {
  data() {
    return {
      md: new MarkdownIt({ html: true }),
      downloadFileWithNewFilename,
      evaluationMethodIcon,
      innerI18n,
      downloadIcon
    }
  },
  computed: {
    ...mapState({
      resource: state => state.resource.resource,
      customFields: state => state.userInfo.customFields
    }),
    evaluationMethods() {
      return this.resource.evaluationMethods
        .map(met => innerI18n.t(`evaluationMethods.${met.referenceId}`))
        .join(', ')
    },
    showEvaluationMethods() {
      return this.customFields.visibleEvaluationMethod && this.evaluationMethods.length
    },
    globalValuationMaterials() {
      return this.resource.teacherMaterial.globalValuationMaterials
    },
    globalValuation() {
      return this.md.render(this.resource.teacherMaterial.globalValuationSection)
    },
    emptyValuation() {
      return !this.resource.teacherMaterial.globalValuationSection
    }
  },
  methods: {
    downloadAllFiles() {
      const files = this.globalValuationMaterials.map(file => ({ name: file.description, url: file.fileURI }))
      zipFilesFromUrls(files, this.resource.title)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.material {
  align-items: center;
  border-bottom: 1px solid $light-gray;
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  width: 100%;

  &:not(:first-child) {
    margin-top: 15px;
  }
}
</style>
